export const version = "bytes/5.5.0";
//# sourceMappingURL=_version.js.map